<template>
  <div />
</template>

<script>
export default {
  name: 'Logout',
  created() {
    this.$store.dispatch('ui/auth/logout');
  },
};
</script>
